import { Skeleton } from "antd";

const StandingsWidgetSkeleton = ({ loading }) => {
  let numberSkeleton = 4;

  let Skeletons = [];
  for (let i = 0; i < numberSkeleton; i++) {
    Skeletons.push(
      <Skeleton
        key={i}
        active
        loading={loading}
        title={{ width: 100 }}
        paragraph={{
          rows: 9,
          width: 1800,
        }}
      />
    );
  }

  return <div style={{ paddingTop: 10 }}>{Skeletons}</div>;
};

export default StandingsWidgetSkeleton;
